<template>
  <div>
    <div class="page-header page-header-small content-header">
      <div class="container">
        <h3 class="title">Allgemeine Geschäftsbedingungen (AGB)</h3>
        <!--
        <h5 class="description list">
          AutoEdge 24 - Inhaber: Andreas Leibolt<br>
          Grüsener Str. 17a<br>
          35285 Gemünden<br>
          Telefon: +49 176 55980480<br>
          E-Mail: kontakt@autoedge24.de<br>
          Internet: www.autoedge24.de
        </h5>
        -->
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 1 Geltungsbereich</h4>
            <h5 class="description list">
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, Lieferungen und sonstigen Leistungen zwischen AutoEdge 24 - Inhaber Andreas Leibolt (nachfolgend „Verkäufer“) und dem Kunden in der zum Zeitpunkt des Vertragsschlusses gültigen Fassung.<br>
              (2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, der Verkäufer stimmt deren Geltung ausdrücklich schriftlich zu.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 2 Vertragsschluss</h4>
            <h5 class="description list">
              (1) Die Darstellung der Produkte auf der Website oder in Angeboten stellt kein rechtlich bindendes Angebot, sondern eine Aufforderung zur Bestellung dar.<br>
              (2) Durch die Bestellung der gewünschten Ware gibt der Kunde ein verbindliches Angebot auf Abschluss eines Kaufvertrages ab.<br>
              (3) Der Vertrag kommt erst durch ausdrückliche Bestätigung oder durch Auslieferung der Ware zustande.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 3 Preise und Zahlungsbedingungen</h4>
            <h5 class="description list">
              (1) Alle Preise sind Endpreise in Euro. Gemäß § 19 UStG wird keine Umsatzsteuer berechnet und ausgewiesen.<br>
              (2) Versandkosten werden gesondert ausgewiesen.<br>
              (3) Der Kaufpreis ist sofort fällig, sofern keine abweichende Zahlungsfrist vereinbart<br>
              (4) Akzeptierte Zahlungsmethoden werden im Bestellprozess angegeben.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 4 Lieferung und Versand</h4>
            <h5 class="description list">
              (1) Der Versand erfolgt an die vom Kunden angegebene Lieferadresse.<br>
              (2) Liefertermine sind nur verbindlich, wenn sie schriftlich bestätigt wurden.<br>
              (3) Der Verkäufer ist zu Teillieferungen berechtigt, sofern dies dem Kunden zumutbar ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 5 Eigentumsvorbehalt</h4>
            <h5 class="description list">
              Die gelieferte Ware bleibt bis zur vollständigen Bezahlung Eigentum des Verkäufers.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 6 Gewährleistung</h4>
            <h5 class="description list">
              Es gelten die gesetzlichen Gewährleistungsrechte. Bei gebrauchten Waren beträgt die Gewährleistungsfrist 1 Jahr ab Lieferung, sofern der Kunde Unternehmer ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 7 Haftung</h4>
            <h5 class="description list">
              (1) Der Verkäufer haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit.<br>
              (2) Bei leichter Fahrlässigkeit haftet der Verkäufer nur für Schäden aus der Verletzung wesentlicher Vertragspflichten (Kardinalpflichten), jedoch begrenzt auf den vorhersehbaren, vertragstypischen Schaden.<br>
              (3) Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 8 Widerrufsrecht für Verbraucher</h4>
            <h5 class="description list">
              Verbrauchern steht ein Widerrufsrecht nach Maßgabe der untenstehenden Widerrufsbelehrung zu.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 9 Datenschutz</h4>
            <h5 class="description list">
              Der Verkäufer verarbeitet personenbezogene Daten des Kunden nur gemäß der Datenschutzerklärung, die Bestandteil dieser AGB ist.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 10 Streitbeilegung</h4>
            <h5 class="description list">
              Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a><br>
              Der Verkäufer ist weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">§ 11 Schlussbestimmungen</h4>
            <h5 class="description list">
              (1) Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.<br>
              (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Gültigkeit der übrigen Bestimmungen unberührt.
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 ml-auto mr-auto text-center">
            <h4 class="title">Hinweis zum Haftungsausschluss bei Ersatzteilen</h4>
            <h5 class="description list">
              Die gelieferten Ersatzteile dürfen nur durch qualifiziertes Fachpersonal eingebaut werden. Der Einbau erfolgt auf eigene Verantwortung.
              AutoEdge 24 übernimmt keine Haftung für Schäden, die durch unsachgemäße Montage oder Verwendung entstehen.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Tabs, TabPane } from '@/components';

export default {
  name: 'terms',
  bodyClass: 'terms-page'
};
</script>
<style scoped>
.list {
  text-align: left;
  margin-left: 70px;
}
.page-header{
  background-color: white !important;
}
.page-header::before{
  background-color: white !important;
}
.description {
  font-weight: normal;
}

@media only screen and (max-width: 800px) {
  .list {
    margin-left: 10px;
  }
}
</style>
